/**
 * Maps notification types to Chakra color schemes.
 */
export const TYPE_COLORS: Record<string, string> = {
  userJoinedGame: 'blue',
  userRequestedToJoinGame: 'blue',
  userInvitedToJoinGame: 'blue',
  userApprovedRequestToJoinGame: 'blue',
  userCreatedGame: 'blue',
  userCanceledGame: 'red',
  userLeftGame: 'orange',
  userApprovedInvitationToJoinGame: 'blue',
  timeSlotAvailable: 'teal',
  eventCreated: 'purple',
  userJoinedEvent: 'purple',
  cohortNotification: 'cyan',
};

/**
 * Returns the color scheme for a notification type.
 * Defaults to 'gray' for unknown types.
 */
export function getNotificationTypeColor(type: string): string {
  return TYPE_COLORS[type] || 'gray';
}
